import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./FinancialDiplomacyStyles.css";

function FinancialDiplomacy() {
  const [email, setEmail] = useState("");
  const [isUnlocked, setIsUnlocked] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (localStorage.getItem("findipWhitepaperUnlocked") === "true") {
      setIsUnlocked(true);
    }
  }, []);

  const handleWhitepaperAccess = (event) => {
    const trimmedEmail = email.trim();
    if (!trimmedEmail) {
      event.preventDefault();
      setError("Please enter your email address.");
      return;
    }

    setError("");
    setHasSubmitted(true);
  };

  const handleFormSubmitLoaded = () => {
    if (!hasSubmitted) {
      return;
    }
    localStorage.setItem("findipWhitepaperUnlocked", "true");
    setIsUnlocked(true);
  };

  return (
    <>
      <Navbar />
      <div className="findip-container">
        <h1>Financial Diplomacy (FinDIP)</h1>
        <details className="findip-item" open>
          <summary>The Financial Diplomacy Initiative</summary>
          {/* <p className="findip-subtitle">
            Building Financial Integrity and Resilience Globally:
          </p> */}
          <br></br>
          <p>
            Compliance keeps organizations out of trouble. But the firms that thrive in the long run
            are those that turn regulatory mastery into strategic advantage — ones that understand
            not just what they cannot do, but what they are uniquely positioned to do.
          </p>
          <br></br>
          <p>
            That recognition is what gave rise to The Financial Diplomacy Initiative — FCG's
            broader framework for advising clients at the intersection of international finance,
            geopolitical risk, and cross-border capital strategy. While our compliance practice
            addresses the rules of the road, the Initiative addresses the road itself: where markets
            are heading, where relationships need to be built, and how financial decisions can be
            structured to serve both national interests and global opportunity.
            The Initiative brings together senior advisors with backgrounds spanning defense
            finance, sovereign wealth management, digital asset regulation, and multilateral trade
            policy. It operates as a research and advisory platform — producing insight, convening
            stakeholders, and delivering strategic counsel on the forces reshaping the global
            financial order.
            Together, FCG's compliance practice and the Financial Diplomacy Initiative represent a
            complete advisory capability: the precision to navigate today's regulatory environment,
            and the foresight to shape tomorrow's strategic position.
          </p>
        </details>

        {/* <details className="findip-item">
          <summary>Our Mission</summary>
          <p>
            To build financial integrity and resilience globally by strengthening
            the intersection between finance, governance, and diplomacy.
          </p>
          <p>
            We aim to inspire leaders, policymakers, and institutions to use
            financial mechanisms as instruments for cooperation, not division.
          </p>
        </details> */}

        {/* <details className="findip-item">
          <summary>Our Focus Areas</summary>
          <ul>
            <li>
              <strong>Sanctions and Policy:</strong> Understanding how economic
              pressure shapes global negotiations.
            </li>
            <li>
              <strong>Ethical Finance:</strong> Encouraging transparency and
              responsibility in cross-border financial flows.
            </li>
            <li>
              <strong>Economic Peacebuilding:</strong> Exploring how financial
              inclusion supports post-conflict stability.
            </li>
            <li>
              <strong>Leadership and Integrity:</strong> Promoting ethical
              decision-making in international financial governance.
            </li>
          </ul>
        </details> */}

        {/* <details className="findip-item" open>
          <summary>Publications & Insights</summary>
          <p className="findip-subtitle">
            <strong>Whitepaper: Financial Diplomacy vs. "Business Not War"</strong>
          </p>
          <p>
            Our upcoming whitepaper introduces the core concepts and frameworks of
            Financial Diplomacy, the strategic use of economic tools,
            institutional development, and international cooperation to achieve
            security and stability objectives that military force alone cannot
            accomplish.
          </p>

          {!isUnlocked ? (
            <form
              className="findip-gate"
              action="https://formsubmit.co/ddebd2d466589b356b4241bb003fffa1"
              method="POST"
              target="formsubmit-hidden-frame"
              onSubmit={handleWhitepaperAccess}
            >
              <iframe
                title="FormSubmit Hidden Frame"
                name="formsubmit-hidden-frame"
                className="findip-hidden-frame"
                onLoad={handleFormSubmitLoaded}
              ></iframe>
              <input type="hidden" name="name" value="FinDIP Whitepaper Request" />
              <input type="hidden" name="_subject" value="New Whitepaper Download Request" />
              <input type="hidden" name="subject" value="FinDIP Whitepaper Request" />
              <input
                type="hidden"
                name="message"
                value="A visitor requested access to the Financial Diplomacy whitepaper."
              />
              <input type="hidden" name="source" value="Frigga FinDIP whitepaper gate" />
              <input type="hidden" name="_template" value="table" />
              <input type="hidden" name="_captcha" value="false" />
              <label htmlFor="whitepaper-email">
                Enter your email to access the white paper:
              </label>
              <input
                id="whitepaper-email"
                type="email"
                name="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="you@example.com"
                required
              />
              <button className="findip-button" type="submit">Get Access</button>
              {error ? <p className="findip-gate-error">{error}</p> : null}
            </form>
          ) : (
            <a
              className="findip-button"
              href={WhitePaper}
              download="Financial-Diplomacy-White-Paper.pdf"
            >
              Download White Paper
            </a>
          )}
        </details> */}

        <details className="findip-item">
          <summary>Join the Conversation</summary>
          <p>
            Stay informed about new insights, articles, and initiatives by
            subscribing to our updates.
          </p>
          <p>
            Follow and engage with #FINDIP on LinkedIn for ongoing discussions
            and thought leadership.
          </p>
          <p>Subscribe to the Financial Diplomacy Newsletter.</p>
          <a
            className="findip-button"
            href="https://www.linkedin.com/newsletters/financial-diplomacy-insights-7385741382679969792/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Financial Diplomacy Insights on LinkedIn
          </a>
          
        </details>

        <details className="findip-item">
          <summary>Contact</summary>
          <p>For collaboration, media, or partnership inquiries, please contact:</p>
          <p>
            <a href="mailto:contact@friggacg.com">contact@friggacg.com</a>
          </p>
        </details>
      </div>
      <Footer />
    </>
  );
}

export default FinancialDiplomacy;
